import { render } from "./App.vue?vue&type=template&id=54bc8ac9"
const script = {}

import "./App.vue?vue&type=style&index=0&id=54bc8ac9&lang=css"
script.render = render

export default script